import React from "react";
import {useState, useEffect} from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { supabase } from '../utils/supabaseClient';
import { Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    Textarea,
    // Input,
    ModalCloseButton,
    ModalBody,
    FormControl,
    FormErrorMessage,
    useToast,
    Button } from "@chakra-ui/react"


const ReviewModal = (props) => {

  const initialRef = React.useRef(null)
  const finalRef = React.useRef(null)

  const [reviewEntry, setReviewEntry] = useState();
  const toast = useToast();

  // console.log(props.requestObject);

  const formik = useFormik({
    initialValues: {
      review: ''
    },
    validationSchema: Yup.object({
      review: Yup.string()
        .max(1000, 'Ne daugiau kaip 1000 simbolių!')
    }),
    onSubmit: async (values) => {
        const { data: { session } } = await supabase.auth.getSession();
        const apiBearer = session?.access_token || null;
        const apiUserUuid = session?.user?.id || null;
        if (!apiBearer || !apiUserUuid) {
          return;
        }
        fetch('https://sckumwyv6l.execute-api.eu-central-1.amazonaws.com/reviews', {
          headers: {
            Authorization: `Bearer ${apiBearer}`,
            "Content-Type": "application/json"
          },
          method: 'POST',
          body: JSON.stringify({
            "userUuid": apiUserUuid,
            // "userUuid": props.requestObject.userUuid,
            "requestUuid": props.requestObject.requestUuid,
            "review": values.review})
        })
        .then(async (response) => {
      if (!response.ok) {
        // Extract error message for debugging if available
        const errorText = await response.text();
        throw new Error(`HTTP ${response.status}: ${errorText}`);
      }

      // Try to parse JSON only if the content type is JSON
      const contentType = response.headers.get("content-type");
      let data;
      if (contentType && contentType.includes("application/json")) {
        data = await response.json();
      } else {
        data = await response.text(); // handle plain text (like "OK")
      }

      setReviewEntry(values.review);
      props.onReviewModalClose();
      props.onReviewSuccess(true);
      toast({
        title: 'Ačiū',
        description: "Atsiliepimas išsaugotas",
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
    })
    .catch((error) => {
      console.error("API Error:", error);
      toast({
        title: 'Klaida',
        description: 'Nepavyko išsaugoti atsiliepimo.',
        status: 'error',
        duration: 4000,
        isClosable: true,
      });
    })     
    }});  


  return (
    <Modal
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
        isOpen={props.isOpen}
        onClose={props.onReviewModalClose}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Palikti atsiliepimą</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <FormControl isInvalid={formik.touched.review && formik.errors.review}>
              <Textarea
                id="review"
                placeholder={reviewEntry}
                _placeholder={{ opacity: 1, color: 'black' }}
                {...formik.getFieldProps('review')}
              />
              <FormErrorMessage>{formik.errors.review}</FormErrorMessage>
            </FormControl>
          </ModalBody>

          <ModalFooter>
            <Button 
            colorScheme='white' 
            color='black.500'
            borderColor='black.500'
            borderWidth='2px'
            variant='outline'
            sx={{
              '&:hover': {
                bg: "rgba(251, 143, 255, 0.4)"
              },
            }}
             mr={3} onClick={formik.handleSubmit}>
              Išsaugoti
            </Button>
            <Button 
                  colorScheme='white' 
                  color='black.500'
                  borderColor='black.500'
                  borderWidth='2px'
                  variant='outline'
                  sx={{
                    bg: "#E9E9E9",
                  }}
            onClick={props.onReviewModalClose}
            >Atšaukti</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
  )

};

export default ReviewModal;